<template>
  <svg :width="width"
       :height="height"
       viewBox="0 0 9 8"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M4.49859 7.87558C3.32655 7.87558 2.15381 7.87558 0.981771 7.87558C0.343952 7.87558 0.000728002 7.53799 0.00284232 6.90299C0.00495664 6.31803 -0.0168913 5.73025 0.0345571 5.14881C0.07191 4.72243 0.203703 4.30309 0.30519 3.88304C0.575118 2.76386 0.850684 1.64609 1.12414 0.528324C1.21576 0.149862 1.39124 0.00185937 1.77605 0.00185937C3.5993 -0.000959717 5.42184 -0.000254945 7.24509 0.00185937C7.57703 0.00185937 7.78776 0.151271 7.86388 0.462781C8.23529 1.97522 8.60318 3.48766 8.96121 5.00363C9.00772 5.19885 8.99504 5.41028 8.99715 5.61396C9.00208 6.05867 8.99926 6.50409 8.99856 6.9488C8.99856 7.53094 8.65463 7.87487 8.06826 7.87628C6.8786 7.87769 5.68824 7.87628 4.49859 7.87628V7.87558ZM0.713253 4.5117C0.802759 4.5117 0.866189 4.5117 0.929618 4.5117C1.43353 4.5117 1.93815 4.51593 2.44206 4.50958C2.62319 4.50747 2.73877 4.57724 2.81559 4.74005C2.93752 4.9994 3.07354 5.25241 3.19687 5.51107C3.23986 5.60128 3.29061 5.64004 3.39703 5.63933C4.13563 5.6344 4.87494 5.6344 5.61354 5.63933C5.72066 5.64004 5.76788 5.59705 5.81017 5.50825C5.93632 5.24466 6.07234 4.98601 6.1992 4.72313C6.27039 4.57583 6.37469 4.50747 6.54525 4.50958C7.0555 4.51663 7.56576 4.5124 8.07531 4.5124C8.13662 4.5124 8.19794 4.5124 8.27546 4.5124C7.94845 3.1825 7.62919 1.88149 7.30781 0.574839H1.68161C1.36023 1.8829 1.03956 3.18602 0.713253 4.5124V4.5117ZM8.41642 5.06495C7.84132 5.06495 7.28526 5.06283 6.72919 5.06917C6.68691 5.06917 6.62911 5.12062 6.60586 5.16291C6.45222 5.44411 6.3028 5.72743 6.15903 6.01357C6.09983 6.13197 6.01455 6.18976 5.88276 6.18976C4.96797 6.18906 4.05388 6.18906 3.13908 6.18976C3.00235 6.18976 2.90932 6.13338 2.8466 6.00793C2.7134 5.74153 2.56328 5.48288 2.43642 5.21365C2.37934 5.09243 2.30745 5.06001 2.17988 5.06213C1.71121 5.06988 1.24183 5.0727 0.773159 5.06072C0.608947 5.05649 0.557498 5.11076 0.558203 5.26651C0.561022 5.82892 0.554679 6.39062 0.554679 6.95303C0.554679 7.22578 0.654052 7.32374 0.926094 7.32374C3.31245 7.32445 5.69881 7.32374 8.08447 7.32374C8.3544 7.32374 8.44461 7.23424 8.44461 6.96713C8.44602 6.43432 8.44602 5.90151 8.4439 5.3687C8.4439 5.27144 8.42699 5.17489 8.41642 5.06565V5.06495Z"
          fill="black"/>
  </svg>
</template>

<script>
export default {
  name: 'EndingIcon',
  props: {
    width: {
      type: Number,
      default: 12
    },
    height: {
      type: Number,
      default: 12
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>

<style>

</style>
